import Button, { ButtonProps } from "@amzn/awsui-components-react-v3/polaris/button";
import { Box, IconProps, Link } from "@amzn/awsui-components-react-v3";
import * as React from "react";
import {useEffect, useState} from "react";
import {handleFileDownload} from "./S3Helper";
import {useApolloClient} from "@apollo/react-hooks";
import {getShipmentPreSignedUrl} from "../gql/queries/get_pre_signed_url";
import './CustomReactComponents.css';

interface DownloadS3FileProps {
    variant: ButtonProps.Variant;
    text: any;
    s3Uri: string | undefined;
    onError: (e: string) => void;
    onErrorMessage: string;
    disabled?: boolean | undefined;
    icon?: IconProps.Name | null;
    onSuccess?: () => void | undefined;
    enableLoading: boolean;
    getPreSignedUrl?: (uri: string) => Promise<any>;
}

interface DownloadS3FileFromLinkProps {
    text: string;
    s3Uri: string | undefined;
    onError: (e: string) => void;
    onErrorMessage: string;
    onSuccess?: () => void | undefined;
}

export function DownloadS3File (props: DownloadS3FileProps){

    const [isDownloadButtonClicked, setIsDownloadButtonClicked] = useState<boolean | undefined>(false);

    useEffect(() => {
        (props.disabled === undefined) ? setIsDownloadButtonClicked(false) : setIsDownloadButtonClicked(props.disabled);
    },[props.disabled]);

    const client = useApolloClient();
    const getPreSignedUrl = props.getPreSignedUrl || getShipmentPreSignedUrl.bind(client);

    const onClick = () => {
        setIsDownloadButtonClicked(true);
        handleFileDownload(
            props.s3Uri,
            getPreSignedUrl,
            props.onErrorMessage)
            .then(() => {
                setIsDownloadButtonClicked(false);
                return (props.onSuccess === undefined) ? null : props.onSuccess();
            })
            .catch((e) => {
                setIsDownloadButtonClicked(false);
                props.onError(e);
            });

    };

    return (
        <Button
            iconName={props.icon!}
            variant={props.variant}
            disabled={isDownloadButtonClicked}
            loading={props.enableLoading && isDownloadButtonClicked}
            onClick={onClick}
        >
            {props.text}
        </Button>
    );
}

export function DownloadS3FileFromLink (props: DownloadS3FileFromLinkProps) {

    const client = useApolloClient();
    const getPreSignedUrl = getShipmentPreSignedUrl.bind(client);

    const onClick = (e: any) => {
        handleFileDownload(
            props.s3Uri,
            getPreSignedUrl,
            props.onErrorMessage)
            .then(() => {
                return (props.onSuccess === undefined) ? null : props.onSuccess();
            })
            .catch((e) => {
                props.onError(e);
            });
        e.preventDefault();
    };

    return (
        <Box variant="span" fontSize="body-s">
            <Link fontSize="body-s" href="/" onFollow={(e) => onClick(e)}> {props.text} </Link>
        </Box>
    );
}